import { BehaviorSubject, Subject } from "rxjs";

class EventsHub {
  showAlert;
  fichaEmpresaChangedSubject;
  loggedInSubject;
  userNameSubject;
  disabledFields;
  periodoFiscalND;

  constructor() {
    this.showAlert = new Subject();
    this.periodoFiscalND = new BehaviorSubject(null);
    this.fichaEmpresaChangedSubject = new BehaviorSubject(null);
    this.disabledFieldsSubject = new BehaviorSubject(false);
    this.loggedInSubject = new BehaviorSubject(false);
    this.userNameSubject = new BehaviorSubject("");
  }

  setShowAlert(message) {
    this.showAlert.next(message);
  }
  onShowAlertEvent() {
    return this.showAlert.asObservable();
  }

  setLoggedIn(loggedIn) {
    this.loggedInSubject.next(loggedIn);
  }
  onLoggedInChanged() {
    return this.loggedInSubject.asObservable();
  }

  setUserName(userName) {
    this.userNameSubject.next(userName);
  }
  onUserNameChanged() {
    return this.userNameSubject.asObservable();
  }

  setFichaEmpresa(fichaEmpresa) {
    this.fichaEmpresaChangedSubject.next(fichaEmpresa);
  }
  onFichaEmpresaChanged() {
    return this.fichaEmpresaChangedSubject.asObservable();
  }

  setPeriodoFiscalND(value) {
    this.periodoFiscalND.next(value);
  }
  onPeriodoFiscalNDChanged() {
    return this.periodoFiscalND.asObservable();
  }
}

const eventsHub = new EventsHub();

export default eventsHub;
